import {HttpContextToken} from '@angular/common/http';

export const RETURN_FULL_RESPONSE = new HttpContextToken(() => false);
